import {any} from 'prop-types';
import React, {Component} from 'react';
import {MultiSelect} from '@blueprintjs/select';
import {Classes, Intent, Tooltip, Callout, MenuItem, Tag} from '@blueprintjs/core';
import toastr from 'toastr';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InfoCircle from '../common/InfoCircle';
import Input from '../common/Input';
import InputRegular from '../common/InputRegular';
import TagsMultiselector from '../common/TagsMultiselector';
import TextArea from '../common/TextArea';
import SmsCounter from 'sms-counter';


class NewTrigger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editActive: false,
            name: '',
            keywords: '',
            actions: [
                {
                    type: 'sms',
                    value: '',
                    characterCount: 0,
                    messagesCount: 1,
                    charsRemaining: 320,
                    charsPerMessage: 320,
                }
            ],
            // replyWithSmsAdded: true,
            // assignTagAdded: false,
            // notifyWebhookAdded: false,
            // addActionActive: false,
            spinnerActive: false,
            fieldsCheckActive: '',
            errorsList: [],
            exceedingError: false

        }
    }


    async componentDidMount() {
    }

    async componentDidUpdate() {
    }

    toggleNewTrigger = () => {
        this.state.editActive ?
            this.setState({
                editActive: false,
                name: '',
                keywords: '',
                actions: [
                    {
                        type: 'sms',
                        value: '',
                        characterCount: 0,
                        messagesCount: 1,
                        charsRemaining: 320,
                        charsPerMessage: 320,
                    }
                ],
                fieldsCheckActive: '',
                errorsList: []
            })
            :
            this.setState({
                editActive: true
            })
    }

    handleAddAction = () => {
        // if((this.state.actions && !this.state.actions.length) || !this.state.replyWithSmsAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Reply with SMS',
        //                 sms: ''
        //             }
        //         ],
        //         replyWithSmsAdded: true,
        //     })
        // }else if(this.state.replyWithSmsAdded && !this.state.assignTagAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Assign Tag',
        //                 tags: []
        //             }
        //         ],
        //         assignTagAdded: true
        //     })
        // }else if(this.state.replyWithSmsAdded && this.state.assignTagAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Webhook URL',
        //                 url: ''
        //             }
        //         ],
        //         notifyWebhookAdded: true,
        //     })
        // }
        this.setState({
            actions: [
                ...this.state.actions,
                {
                    type: 'sms',
                    value: '',
                    characterCount: 0,
                    messagesCount: 1,
                    charsRemaining: 320,
                    charsPerMessage: 320,
                }
            ],
            // replyWithSmsAdded: true,
        })
    }

    handleChangeAction = (selectedAction, actionIndex) => {
        let actions = this.state.actions;
        let actionBeforeChange = actions[actionIndex];

        if (selectedAction === 'sms') {

            actions[actionIndex] = {
                type: 'sms',
                value: '',
                characterCount: 0,
                messagesCount: 1,
                charsRemaining: 320,
                charsPerMessage: 320,
            }

            this.setState({
                actions,
                // replyWithSmsAdded: true,
            })
        } else if (selectedAction === 'tags') {
            actions[actionIndex] = {
                type: 'tags',
                value: [],
                selectedTags: [],
                selectedTagsIds: []
            }

            this.setState({
                actions,
                // assignTagAdded: true,
            })
        } else if (selectedAction === 'remove_tags') {
            actions[actionIndex] = {
                type: 'remove_tags',
                value: [],
                selectedTags: [],
                selectedTagsIds: []
            }

            this.setState({
                actions,
                // assignTagAdded: true,
            })
        } else if (selectedAction === 'webhook') {
            actions[actionIndex] = {
                type: 'webhook',
                value: ''
            }

            this.setState({
                actions,
                // notifyWebhookAdded: true,
            })
        } else if (selectedAction === 'subscription') {
            actions[actionIndex] = {
                type: 'subscription',
                value: 1
            }

            this.setState({
                actions,
                // notifyWebhookAdded: true,
            })
        }

        // if(actionBeforeChange.selected === 'Reply with SMS'){
        //     this.setState({replyWithSmsAdded: false})
        // }else if(actionBeforeChange.selected === 'Assign Tag'){
        //     this.setState({assignTagAdded: false})
        // }else if(actionBeforeChange.selected === 'Webhook URL'){
        //     this.setState({notifyWebhookAdded: false})
        // }
    }

    handleRemoveAction = (index) => {
        let array = [...this.state.actions]; // make a separate copy of the array
        array.splice(index, 1);
        this.setState({actions: array});
    }

    handleActionUpdate = (type, index, value) => {
        if (type === 'sms') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                type,
                value: value,
                characterCount: SmsCounter.count(value).length,
                messagesCount: SmsCounter.count(value).messages,
                charsRemaining: SmsCounter.count(value).remaining,
                charsPerMessage: SmsCounter.count(value).per_message,
            }
            this.setState({actions})
        } else if (type === 'tags') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                type,
                value: value,
                selectedTags: [],
                selectedTagsIds: []
            }
            this.setState({actions})
            this.handleTagsToFullTags(value, index)
        } else if (type === 'webhook') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                type,
                value: value
            }
            this.setState({actions})
        } else if (type === 'subscription') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                type,
                value: value
            }
            this.setState({actions})
        }
        if (SmsCounter.count(value).length > 320) {
            // console.log('length > 320')
            this.setState({
                exceedingError: true
            })
            document.querySelector('textarea.register-password[placeholder="Enter message here"]').classList.add('exceeding-error-textarea')
        } else {
            //console.log('length < 320')
            this.setState({
                exceedingError: false
            })
            document.querySelector('textarea.register-password[placeholder="Enter message here"]').classList.remove('exceeding-error-textarea')
        }

    }

    multiMenuItem = (item, tags, {modifiers, handleClick}) => {
        if (tags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />

            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    };

    tagSelect = async (item, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = this.state.actions[index].selectedTagsIds || [];
        //console.log('tag select item:', item);
        const selectedTags = this.state.actions[index].selectedTags || [];
        let selectedTagsNames = this.state.actions[index].value || [];


        //console.log('selected tags ids:', selectedTagsIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            selectedTagsIds.push(item.id)
            selectedTagsNames.push(item.tag)
            actions[index] = {
                ...actions[index],
                selectedTags,
                selectedTagsIds,
                value: selectedTagsNames
            }
            this.setState({actions});
        } else {
            const newTags = selectedTags.filter(t => t !== item);
            const newTagsIds = [];
            const newTagsNames = [];
            newTags.map(tag => {
                newTagsIds.push(tag.id)
                newTagsNames.push(tag.tag)
            })
            actions[index] = {
                ...actions[index],
                selectedTags: newTags,
                selectedTagsIds: newTagsIds,
                value: newTagsNames
            }
            this.setState({actions});
        }

        // this.state.actions[index].value.map(tag => {
        //     selectedTagsIds = [...selectedTagsIds, tag.id]
        // });

    };

    handleTagRemove = async (item, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = [];
        let selectedTagsNames = await [];

        const selectedTags = this.state.actions[index].value;
        const fullTags = this.state.actions[index].selectedTags;
        // console.log('handleTagRemove: ', item, selectedTags, fullTags)
        const newTags = [];

        const newFullTags = fullTags.filter(t => t.tag !== item.props.children);
        newFullTags.map(tag => newTags.push(tag.id))

        newTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
            selectedTagsNames = [...selectedTagsNames, tag.tag]
        });


        actions[index] = {
            ...actions[index],
            selectedTags: newFullTags,
            selectedTagsIds,
            value: selectedTagsNames
        }

        this.setState({actions});

    };

    tagRender = (item) => {


        // console.log('tag render item:', item);
        // console.log('')
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
        // console.log('tag render end');
    };

    filterTags = (item) => {

        //console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    handleSaveTrigger = async () => {
        let userId = this.props.user.id;
        let selectedSource = this.props.selectedSource;
        this.setState({spinnerActive: true, fieldsCheckActive: true})
        let selectedItem = this.props.selectedItem
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            let checkTagsEmpty = false;
            this.state.actions.map(action => ((action.type === 'tags') || (action.type === 'remove_tags')) && action.value && !action.value.length ? checkTagsEmpty = true : '')
            if (!anyErrorActive && !checkTagsEmpty) {
                let preparedActions = [];
                await this.state.actions.map(action => preparedActions.push({
                    type: action.type,
                    value: action.value
                }))
                // this.props.handleSave({
                //     title: this.state.title,
                //     keywords: this.state.keywords.split(',').map(item => item.trim()).filter(x=>x),
                //     message: this.state.message,
                //     actions: this.state.actions
                // });
                try {
                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)
                    let tags = await http.post('api/user/' + userId + '/project/' + selectedSource + '/workspace_triggers', {
                        "name": this.state.name,
                        "type": "custom",
                        "keywords": this.state.keywords.split(',').map(item => item.trim()).filter(x => x),
                        "actions": preparedActions
                    }, {headers: {authorization: getJwt()}});
                    this.props.handleGetTriggers();
                    this.toggleNewTrigger();
                    this.setState({spinnerActive: false})
                } catch (ex) {
                    this.setState({spinnerActive: false})
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                }
            } else {
                this.setState({spinnerActive: false})
            }
        }, 500)
    }

    updateTags = async (tags, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = await [];
        let selectedTagsNames = await [];
        await tags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
            selectedTagsNames = [...selectedTagsNames, tag.tag]
        })
        actions[index] = {
            ...actions[index],
            selectedTags: tags,
            selectedTagsIds,
            value: selectedTagsNames
        }
        await this.setState({actions});
    }

    render() {

        return (
            this.state.editActive ?
                <div className="single-trigger-container active">
                    <h3>Create Custom Trigger</h3>
                    <p className="margin-bottom-20">Specify unique keywords and responses.</p>

                    {/*<p className='input-label'>Trigger Name</p>*/}
                    <InputRegular
                        id="1"
                        label1="Trigger Name"
                        label2=""
                        placeholder="Enter Trigger Name"
                        type='text'
                        textArea={false}
                        onChange={e => this.setState({name: e})}
                        value={this.state.name}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="Name must be a at list 2 characters"
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        required={true}
                    />
                    {/*<Input*/}
                    {/*    className={'input'}*/}
                    {/*    value={this.state.title}*/}
                    {/*    placeHolder={'Enter Trigger Name'}*/}
                    {/*    onChange={({currentTarget: input}) => input ? this.setState({ title: input.value}) : ''}*/}
                    {/*/>*/}

                    <div className="new-trigger-bottom-border">
                        <InputRegular
                            id="2"
                            label1="Keywords"
                            label2=""
                            placeholder="Enter keywords"
                            type='text'
                            textArea={true}
                            oneLineTextArea={true}
                            onChange={e => this.setState({keywords: e})}
                            value={this.state.keywords}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="You can enter up to 20 keywords separated by commas."
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            required={true}
                        />
                        {/*<p className='input-label'>Keywords</p>*/}
                        {/*<TextArea*/}
                        {/*    className={'input'}*/}
                        {/*    value={this.state.keywords}*/}
                        {/*    placeholder={'Enter keywords'}*/}
                        {/*    onChange={({currentTarget: input}) => input ? this.setState({ keywords: input.value}) : ''}*/}
                        {/*/>*/}
                        <p className='input-explanation'>Enter up to 20 keywords separated by commas.</p>

                        {/*<p className='input-label'>Confirmation Message</p>*/}
                        {/*<TextArea*/}
                        {/*    className={'input'}*/}
                        {/*    rows={2}*/}
                        {/*    value={this.state.message}*/}
                        {/*    placeholder={'Enter message here'}*/}
                        {/*    onChange={({currentTarget: input}) => input ? this.setState({ message: input.value}) : ''}*/}
                        {/*/>*/}
                        {/*<p className='input-explanation'>Enter a confirmation message that users will receive upon sending your custom response.</p>*/}
                    </div>
                    {
                        this.state.actions && this.state.actions.length ?
                            this.state.actions.map((action, index) => {
                                return <div className="new-trigger-bottom-border">
                                    <div className="space-between margin-bottom-10 margin-top-20">
                                        <span><strong>Action #{index + 1}</strong></span>
                                        {this.state.actions.length > 1 ?
                                            <a onClick={() => this.handleRemoveAction(index)}>Remove action</a>
                                            :
                                            ''
                                        }
                                    </div>
                                    <div className="tabs-navigation">
                                        <div
                                            className={action.type === 'sms' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                            onClick={() => !this.state.replyWithSmsAdded ? this.handleChangeAction('sms', index) : ''}
                                        >
                                            Reply with SMS
                                        </div>
                                        <div
                                            className={action.type === 'tags' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                            onClick={() => !this.state.assignTagAdded ? this.handleChangeAction('tags', index) : ''}
                                        >
                                            Assign Tag
                                        </div>
                                        <div
                                            className={action.type === 'remove_tags' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                            onClick={() => !this.state.removeTagAdded ? this.handleChangeAction('remove_tags', index) : ''}
                                        >
                                            Remove Tag
                                        </div>
                                        <div
                                            className={action.type === 'webhook' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                            onClick={() => !this.state.notifyWebhookAdded ? this.handleChangeAction('webhook', index) : ''}
                                        >
                                            Webhook URL
                                        </div>
                                        <div
                                            className={action.type === 'subscription' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                            onClick={() => this.handleChangeAction('subscription', index)}
                                        >
                                            Event
                                        </div>
                                    </div>
                                    {
                                        action.type === 'sms' ?
                                            <div className="new-trigger-action-container">
                                                <InputRegular
                                                    id={index + 3}
                                                    label1="Response Message"
                                                    label2=""
                                                    placeholder="Enter message here"
                                                    type='text'
                                                    textArea={true}
                                                    onChange={value => this.handleActionUpdate('sms', index, value)}
                                                    value={this.state.actions[index].value}
                                                    updateErrorsList={this.updateErrorsList}
                                                    errorMessage="Message can't be empty"
                                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                                    required={true}
                                                />
                                                <p className='character-count'>
                                                    Characters:<span>{(this.state.actions[index].characterCount + '/' +
                                                    this.state.actions[index].charsPerMessage * this.state.actions[index].messagesCount)} </span>
                                                    Messages: <span>{this.state.actions[index].messagesCount}</span>
                                                </p>
                                                <p className='character-count'></p>
                                                {/*<p className='input-label'>Response Message</p>*/}
                                                {/*<TextArea*/}
                                                {/*    className={ 'input' }*/}
                                                {/*    value={ this.state.message }*/}
                                                {/*    placeholder={ 'Enter message here' }*/}
                                                {/*    onChange={ ({ currentTarget: input }) => this.handleActionUpdate('Reply with SMS', index, input.value)}*/}
                                                {/*/>*/}
                                                {this.state.exceedingError ?
                                                    <p className='text-red exceeding-error'>
                                                        One auto-response message can't contain more than 320
                                                        characters. For additional content add an additional Reply with
                                                        SMS action.
                                                    </p>
                                                    : ''
                                                }
                                                <p className='input-explanation'>When someone sends you the message
                                                    containing trigger word, this SMS message will be sent as a
                                                    confirmation to the user automatically..</p>
                                            </div>
                                            :
                                            (action.type === 'tags') || (action.type === 'remove_tags') ?
                                                <div className={
                                                    this.state.fieldsCheckActive && !this.state.actions[index].value.length ?
                                                        "new-trigger-action-container multi-select-error-container" :
                                                        "new-trigger-action-container multi-select-container"}
                                                >
                                                    <p className='input-label'>
                                                        {
                                                            action.type === 'tags' ? 'Assign these tags to the Sender' : 'Remove these tags from the Sender'
                                                        }
                                                    </p>
                                                    <TagsMultiselector
                                                        tags={this.props.tags}
                                                        selectedTags={this.state.actions[index].selectedTags}
                                                        selectedTagsIds={this.state.actions[index].selectedTagsIds}
                                                        squareType={true}
                                                        width={'100%'}
                                                        updateTags={tags => this.updateTags(tags, index)}
                                                        // updateTagsIds={ this.updateTagsIds }
                                                        handleCreateTag={this.props.handleCreateTag}
                                                        handleGetTags={this.props.handleGetTags}
                                                        dontHandleGetTags={true}
                                                    />
                                                    <div className="margin-bottom-20"/>
                                                </div>
                                                :
                                                action.type === 'webhook' ?
                                                    <div className="new-trigger-action-container">
                                                        {/*<p className='input-label'>Webhook URL</p>*/}
                                                        <InputRegular
                                                            id={index + 3}
                                                            label1="Webhook URL"
                                                            label2=""
                                                            placeholder="Enter URL"
                                                            type='url'
                                                            onChange={e => this.handleActionUpdate('webhook', index, e)}
                                                            value={this.state.actions[index].value}
                                                            updateErrorsList={this.updateErrorsList}
                                                            errorMessage="Must be a valid url"
                                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                                            required={true}
                                                        />
                                                    </div>
                                                    :
                                                    <div>
                                                        <p className='input-label'>Subscribe or Unsubscribe this
                                                            contact</p>
                                                        <div className="tabs-navigation">
                                                            <div
                                                                className={parseInt(action.value) === 1 ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                                onClick={() => this.handleActionUpdate('subscription', index, 1)}
                                                            >
                                                                Subscribe contact
                                                            </div>
                                                            <div
                                                                className={parseInt(action.value) === 0 ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                                onClick={() => this.handleActionUpdate('subscription', index, 0)}
                                                            >
                                                                Unsubscribe contact
                                                            </div>
                                                        </div>
                                                    </div>
                                    }
                                </div>
                            })
                            :
                            ''
                    }


                    <div className="flex-direction-row space-between">
                        <button
                            // disabled={this.state.actions && (this.state.actions.length > 2)}
                            onClick={this.handleAddAction}
                            className='btn-white btn-small'
                        >
                            Add Action
                        </button>
                        <div className="flex-direction-row flex-end">

                            <button onClick={this.toggleNewTrigger}
                                    className='btn-white btn-small margin-right-10'>Cancel
                            </button>
                            {this.state.spinnerActive ?
                                <button className='btn-action btn-small btn-spinner'>Create <i
                                    className='fa fa-spin fa-spinner'></i></button>
                                :
                                <button onClick={this.handleSaveTrigger}
                                        className='btn-action btn-small'>Create</button>
                            }

                        </div>
                    </div>

                </div>
                :
                <div className='new-trigger-container flex-direction-row justify-content-space'>
                    <div className='left-part'>
                        <h3>Create Custom Trigger</h3>
                        <p>Specify unique keywords and responses.</p>
                    </div>
                    <button onClick={this.toggleNewTrigger} className='btn-action btn-small'>Create New Trigger</button>
                </div>
        )

    }
}


export default NewTrigger;